import { render, staticRenderFns } from "./numberBox.vue?vue&type=template&id=7db0f2e8&scoped=true&"
import script from "./numberBox.vue?vue&type=script&lang=js&"
export * from "./numberBox.vue?vue&type=script&lang=js&"
import style0 from "./numberBox.vue?vue&type=style&index=0&id=7db0f2e8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db0f2e8",
  null
  
)

export default component.exports